import { useOrgValue } from 'hooks/business/system/useOrg';
import type { OrgValue } from 'hooks/business/system/useOrg';

export const useBeisiFeature = () => {
  const orgValue = useOrgValue();
  return isBeisi(orgValue);
};

export const isBeisi = (orgValue?: OrgValue) => {
  if (import.meta.env.VITE_ENV === 'staging' || import.meta.env.VITE_ENV === 'feature') {
    return localStorage.getItem('beisi') === 'true';
  }
  return orgValue?.orgId === 7289;
};
